import { render, staticRenderFns } from "./hintDetail.vue?vue&type=template&id=2438b5c7&scoped=true&"
import script from "./hintDetail.vue?vue&type=script&lang=js&"
export * from "./hintDetail.vue?vue&type=script&lang=js&"
import style0 from "./hintDetail.vue?vue&type=style&index=0&id=2438b5c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2438b5c7",
  null
  
)

export default component.exports